var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "shop",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.099,
    height: 20.168,
    viewBox: "0 0 23.099 20.168",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13",
    "data-name": "Grupo 13",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_809",
    "data-name": "Caminho 809",
    d: "M252.9,263.75h-3.139a1.559,1.559,0,0,0-1.558,1.558v2.407a1.559,1.559,0,0,0,1.558,1.558H252.9a1.559,1.559,0,0,0,1.558-1.558v-2.407A1.559,1.559,0,0,0,252.9,263.75Zm.425,3.965a.426.426,0,0,1-.425.425h-3.139a.426.426,0,0,1-.425-.425v-2.407a.426.426,0,0,1,.425-.425H252.9a.426.426,0,0,1,.425.425Z",
    transform: "translate(-236.485 -252.767)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_810",
    "data-name": "Caminho 810",
    d: "M23.1,37.658a.526.526,0,0,0-.076-.278l-3.436-6.041a.569.569,0,0,0-.491-.288H4a.56.56,0,0,0-.491.288L.076,37.379A.573.573,0,0,0,0,37.658a3.313,3.313,0,0,0,1.982,3.03v9.964a.568.568,0,0,0,.566.566h18a.568.568,0,0,0,.566-.566V40.759a.249.249,0,0,0,0-.061A3.323,3.323,0,0,0,23.1,37.658ZM4.328,32.188H18.766l2.686,4.725H1.647ZM16.439,38.04a2.177,2.177,0,0,1-4.286,0Zm-5.489,0a2.18,2.18,0,0,1-4.29,0Zm-9.78,0h4.29a2.18,2.18,0,0,1-4.29,0ZM9.515,50.085H6.259V43.973a.807.807,0,0,1,.807-.807H8.713a.807.807,0,0,1,.807.807v6.112Zm10.464,0H10.648V43.973a1.943,1.943,0,0,0-1.94-1.94H7.061a1.943,1.943,0,0,0-1.94,1.94V50.09H3.115V40.967c.066,0,.132,0,.2,0A3.309,3.309,0,0,0,6.06,39.508a3.31,3.31,0,0,0,5.494,0,3.3,3.3,0,0,0,5.485,0,3.309,3.309,0,0,0,2.747,1.463c.066,0,.127,0,.194,0v9.119Zm-.194-10.247a2.176,2.176,0,0,1-2.143-1.794h4.29A2.189,2.189,0,0,1,19.786,39.838Z",
    transform: "translate(0 -31.05)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.205fe65e3dccb337986c3598e4ccbb4e.svg";
export { ForwardRef as ReactComponent };